import { ConsultationUtils } from '../../../consult-utils';
import { FormType } from '../../../form-types';
import { Answers } from '@care-portals/api-interfaces';

export const acneBeluga: FormType = {
  name: 'Acne Visit',

  questions: [
    {
      key: 'acneBeluga_sexAssignedAtBirth',
      next: {
        condition: {
          'acneBeluga_sexAssignedAtBirth.acneBeluga_sexAssignedAtBirth_female':
            true
        },
        key: 'acneBeluga_pregnancy',
        els: 'acneBeluga_severity'
      }
    },
    {
      key: 'acneBeluga_pregnancy',
      next: {
        condition: {
          'acneBeluga_pregnancy.acneBeluga_pregnancy_yes': true
        },
        key: 'acneBeluga_ineligible',
        els: 'acneBeluga_pregnancyConsent'
      }
    },
    {
      key: 'acneBeluga_pregnancyConsent',
      next: {
        condition: {
          'acneBeluga_pregnancyConsent.acneBeluga_pregnancyConsent_disagree':
            true
        },
        key: 'acneBeluga_ineligible',
        els: 'acneBeluga_severity'
      }
    },
    'acneBeluga_severity',
    {
      key: 'acneBeluga_location',
      next: {
        condition: {
          'acneBeluga_location.acneBeluga_location_other': true
        },
        key: 'acneBeluga_outbreakPattern',
        els: 'acneBeluga_duration'
      }
    },
    'acneBeluga_outbreakPattern',
    'acneBeluga_duration',
    {
      key: 'acneBeluga_triggers',
      next: {
        condition: {
          'acneBeluga_triggers.acneBeluga_triggers_other': true
        },
        key: 'acneBeluga_triggersDetails',
        els: 'acneBeluga_previousTreatment'
      }
    },
    'acneBeluga_triggersDetails',
    {
      key: 'acneBeluga_previousTreatment',
      next: {
        condition: {
          'acneBeluga_previousTreatment.acneBeluga_previousTreatment_yes': true
        },
        key: 'acneBeluga_previousTreatmentTypes',
        els: 'acneBeluga_skinSensitivity'
      }
    },
    {
      key: 'acneBeluga_previousTreatmentTypes',
      next: {
        condition: {
          'acneBeluga_previousTreatmentTypes.acneBeluga_previousTreatmentTypes_other':
            true
        },
        key: 'acneBeluga_previousTreatmentDetails',
        els: 'acneBeluga_treatmentEffectiveness'
      }
    },
    'acneBeluga_previousTreatmentDetails',
    'acneBeluga_treatmentEffectiveness',
    {
      key: 'acneBeluga_adverseReactions',
      next: {
        condition: {
          'acneBeluga_adverseReactions.acneBeluga_adverseReactions_yes': true
        },
        key: 'acneBeluga_adverseReactionsDetails',
        els: 'acneBeluga_skinSensitivity'
      }
    },
    'acneBeluga_adverseReactionsDetails',
    'acneBeluga_skinSensitivity',
    'acneBeluga_skinInfections',
    {
      key: 'acneBeluga_medicalHistory',
      next: {
        condition: {
          'acneBeluga_medicalHistory.acneBeluga_medicalHistory_other': true
        },
        key: 'acneBeluga_medicalHistoryDetails',
        els: 'acneBeluga_hormonalImbalance'
      }
    },
    'acneBeluga_medicalHistoryDetails',
    {
      key: 'acneBeluga_hormonalImbalance',
      next: {
        condition: {
          'acneBeluga_hormonalImbalance.acneBeluga_hormonalImbalance_yes': true
        },
        key: 'acneBeluga_hormonalImbalanceDetails',
        els: 'acneBeluga_tobacco'
      }
    },
    'acneBeluga_hormonalImbalanceDetails',
    'acneBeluga_tobacco',
    'acneBeluga_alcohol',
    {
      key: 'acneBeluga_specificConcerns',
      next: {
        condition: {
          'acneBeluga_specificConcerns.acneBeluga_specificConcerns_yes': true
        },
        key: 'acneBeluga_concernsDetails',
        els: 'acneBeluga_treatmentConsent'
      }
    },
    'acneBeluga_concernsDetails',
    {
      key: 'acneBeluga_treatmentConsent',
      next: {
        condition: {
          'acneBeluga_treatmentConsent.acneBeluga_treatmentConsent_disagree':
            true
        },
        key: 'acneBeluga_ineligible',
        els: 'acneBeluga_complete'
      }
    },
    'acneBeluga_ineligible',
    'acneBeluga_complete'
  ]
};
export const acne: FormType = {
  name: 'Acne',
  questions: [
    'acneTackle',
    'acnePimples',
    'acneBreaking',
    [
      {
        key: 'acneSex',
        next: {
          condition: { 'acneSex.female': true },
          key: 'acnePregnant',
          els: 'acneAllergic'
        }
      },
      {
        key: 'acnePregnant',
        next: {
          condition: { 'acnePregnant.nonePregnant': true },
          key: 'acneBirthControl',
          els: 'acneAllergic'
        }
      },
      {
        key: 'acneBirthControl',
        next: {
          condition: { 'acneBirthControl.birthYes': true },
          key: 'acneBirthControlAcne',
          els: 'acneAllergic'
        }
      },
      {
        key: 'acneBirthControlAcne',
        next: {
          condition: { 'acneBirthControlAcne.birthAcneYes': true },
          key: 'acneBirthControlAcneMore',
          els: 'acneAllergic'
        }
      },
      'acneBirthControlAcneMore'
    ],
    [
      {
        key: 'acneAllergic',
        next: {
          switch: [
            {
              condition: {
                'acneAllergic.yes': true,
                'states.category': 'Mild'
              },
              key: 'acneAllergicMoreMildDrugs'
            },
            {
              condition: {
                'acneAllergic.yes': true,
                'states.category': 'Moderate'
              },
              key: 'acneAllergicMoreModerateDrugs'
            },
            {
              condition: {
                'acneAllergic.yes': true,
                'states.category': 'Severe'
              },
              key: 'acneAllergicMoreSevereDrugs'
            }
          ],
          els: 'acneSkinGoal'
        }
      },
      'acneAllergicMoreMildDrugs',
      {
        key: 'acneAllergicMoreMildDrugsDesc',
        next: { key: 'acneSkinGoal' }
      },

      'acneAllergicMoreModerateDrugs',
      {
        key: 'acneAllergicMoreModerateDrugsDesc',
        next: { key: 'acneSkinGoal' }
      },
      'acneAllergicMoreSevereDrugs',
      'acneAllergicMoreSevereDrugsDesc'
    ],
    'acneSkinGoal',
    'acneSkinType',
    'acneSensitive',
    'acneOver',
    'acneAcknowledgement'
  ],
  saveState: (answers: Answers) => {
    const {
      whiteheads = undefined,
      blackheads = undefined,
      papules = undefined,
      pustules = undefined,

      boils = undefined,
      bLess5 = undefined,
      b5to10 = undefined,
      bMore10 = undefined,

      cysts = undefined,
      cLess5 = undefined,
      c5to10 = undefined,
      cMore10 = undefined,

      nodules = undefined,
      nLess5 = undefined,
      n5to10 = undefined,
      nMore10 = undefined
    } = answers?.acneTackle;

    const {
      s1to3 = undefined,
      s3to7 = undefined,
      s7to10 = undefined,
      sMore10 = undefined
    } = answers?.acnePimples || {};

    const isExtreme =
      (boils && bMore10) || (cysts && cMore10) || (nodules && nMore10);
    const isSevere =
      (boils && b5to10) || (cysts && c5to10) || (nodules && n5to10);
    const isModerate =
      (boils && bLess5) ||
      (cysts && cLess5) ||
      (nodules && nLess5) ||
      papules ||
      pustules;
    const isMild = whiteheads || blackheads;

    return {
      category: isExtreme
        ? 'Extreme'
        : !isExtreme && isSevere
        ? 'Severe'
        : !isExtreme && !isSevere && isModerate
        ? 'Moderate'
        : !isExtreme && !isSevere && !isModerate && isMild
        ? 'Mild'
        : '',
      level: sMore10 || s7to10 ? 'High' : s3to7 ? 'Mid' : s1to3 ? 'Low' : ''
    };
  },
  onSubmit: (answers: Answers, user: string) => {
    ConsultationUtils.answers = answers;
    window.location.href = ConsultationUtils.getAcneUrl(user);
  }
};
